import { jsonMember, jsonObject } from 'typedjson';
import { PublicOrderShipmentMethodResponse } from './public-order-shipment-method.response';
import { ShipmentStatus } from '../../../shared/enums/shipment-status';
import { PublicOrderShippingAddressResponse } from './public-order-shipping-address.response';
import { Guid, Nillable } from '@web/utils';
import { PublicOrderShipmentContextOperationsResponse } from './public-order-shipment-context-operations.response';
import { OrderShipmentRefundSummaryResponse } from '../../../shared/api/responses';

@jsonObject
export class PublicOrderShipmentResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly status!: ShipmentStatus;

  @jsonMember(String)
  public readonly trackingUrl?: Nillable<string>;

  @jsonMember(Number)
  public readonly price!: number;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Date)
  public readonly scheduledShippingDate?: Nillable<Date>;

  @jsonMember(PublicOrderShipmentMethodResponse)
  public readonly method!: PublicOrderShipmentMethodResponse;

  @jsonMember(PublicOrderShippingAddressResponse)
  public readonly address!: PublicOrderShippingAddressResponse;

  @jsonMember(PublicOrderShipmentContextOperationsResponse)
  public readonly contextOperations!: PublicOrderShipmentContextOperationsResponse;

  @jsonMember(OrderShipmentRefundSummaryResponse)
  public readonly refundSummary?: Nillable<OrderShipmentRefundSummaryResponse>;
}
